import axios from 'axios';

export default axios.create({
    baseURL: 'https://fg21gzr12j.execute-api.us-east-1.amazonaws.com/dev'
});